module.exports = __webpack_public_path__ + "img/expense_category_fees.a42473d.png";